import React, { useState } from 'react'
import { Box, Typography, Paper, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { ChevronLeft, ChevronRight } from '@material-ui/icons'
import { alpha } from '@material-ui/core/styles'
import SamplesView from '../KitPanelUploadView/KitsAndPanelsTable'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
  },
  collapsedBar: {
    cursor: 'pointer',
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    backgroundColor: alpha(theme.palette.background.default, 0.72),
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    color: theme.palette.text.primary,
    transition: 'all 0.3s ease-in-out',
    border: '2px solid transparent',
    '&:hover': {
      backgroundColor: alpha(theme.palette.background.default, 0.8),
      border: `2px solid ${theme.palette.text.primary}`,
    },
  },
  verticalBar: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '30px',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.3s ease-in-out',
    border: '2px solid transparent',
    borderRight: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: alpha(theme.palette.background.default, 0.8),
      border: `2px solid ${theme.palette.text.primary}`,
    },
  },
  tableContainer: {
    marginLeft: '30px',
    transition: 'all 0.3s ease-in-out',
    overflow: 'hidden',
  },
  expandingAnimation: {
    animation: '$expand 0.3s ease-in-out',
  },
  collapsingAnimation: {
    animation: '$collapse 0.3s ease-in-out',
  },
  '@keyframes expand': {
    '0%': {
      transform: 'scaleX(0)',
      transformOrigin: 'left',
    },
    '100%': {
      transform: 'scaleX(1)',
      transformOrigin: 'left',
    },
  },
  '@keyframes collapse': {
    '0%': {
      transform: 'scaleX(1)',
      transformOrigin: 'left',
    },
    '100%': {
      transform: 'scaleX(0)',
      transformOrigin: 'left',
    },
  },
}))

const CollapsibleKitsAndPanelsTable = () => {
  const classes = useStyles()
  const [isExpanded, setIsExpanded] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)

  const handleToggle = () => {
    setIsAnimating(true)
    if (isExpanded) {
      setIsExpanded(false)
      setTimeout(() => setShouldRender(false), 300)
    } else {
      setIsExpanded(true)
      setShouldRender(true)
    }
    setTimeout(() => setIsAnimating(false), 300)
  }

  if (!shouldRender && !isExpanded) {
    return (
      <Paper className={classes.collapsedBar} onClick={handleToggle}>
        <ChevronRight />
        <Typography variant="h6" style={{ marginLeft: 8 }}>
          View Kits & Panels
        </Typography>
      </Paper>
    )
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.verticalBar} onClick={handleToggle}>
        <ChevronLeft />
      </Box>
      <Box
        className={`${classes.tableContainer} ${
          isAnimating ? (isExpanded ? classes.expandingAnimation : classes.collapsingAnimation) : ''
        }`}
      >
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <SamplesView isKits={true} />
          </Grid>
          <Grid item xs={6}>
            <SamplesView isKits={false} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default CollapsibleKitsAndPanelsTable
